// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RcW8CRhj9seLr7 {
  color: var(--dynamic-text);
}
.TuQvzm7UFuHc9q {
  display: block;
  max-width: 600px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: 75px auto;
  text-align: center;
}
.TuQvzm7UFuHc9q h1 {
  margin-bottom: var(--ds-space-150, 12px);
  font-size: 26px;
}
.TuQvzm7UFuHc9q p {
  font-size: 18px;
  line-height: 22px;
}
.ORRLepsD8Wi8vr {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: 36px var(--ds-space-0, 0px) 36px var(--ds-space-0, 0px);
}
`, ""]);
// Exports
export var quiet = `RcW8CRhj9seLr7`;
export var bigMessage = `TuQvzm7UFuHc9q`;
export var tryAgainButton = `ORRLepsD8Wi8vr`;
export default ___CSS_LOADER_EXPORT___;
